import { render, staticRenderFns } from "./AboutUpmPdf.vue?vue&type=template&id=ede73748&scoped=true&"
import script from "./AboutUpmPdf.vue?vue&type=script&lang=js&"
export * from "./AboutUpmPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede73748",
  null
  
)

export default component.exports